export var APPS = {
    corrige: {
        image: 'https://pluri-geral.s3.amazonaws.com/icones_aplicacoes/corrige.png',
        chave_sistema: 'ac3478d69a3c81fa62e60f5c3696165a4e5e6ac4',
        name: 'Corrige',
        route: 'corrige',
        sspa_name: '@cosmos/corrige'
    },
    semchamada: {
        name: 'Redação',
        chave_sistema: '1b6453892473a467d07372d45eb05abc2031647a',
        image: 'https://pluri-geral.s3.amazonaws.com/icones_aplicacoes/redacao.png',
        sspa_name: '@cosmos/semchamada',
        route: 'semchamada'
    },
    censo: {
        name: 'Censo',
        chave_sistema: 'de870f876f6ddbd5078a73b535b2e727e13c650a',
        image: 'https://pluri-geral.s3.amazonaws.com/sistemas/parceiros/estudoplay/sistemas/censo.png',
        sspa_name: '@cosmos/censo',
        route: 'censo'
    },
    agenda: {
        name: 'Agenda',
        chave_sistema: 'cf0645b39f53463ecc63a067f6f9b0df05644514',
        image: 'https://pluri-geral.s3.amazonaws.com/sistemas/parceiros/estudoplay/sistemas/agenda.png',
        sspa_name: '@cosmos/agenda',
        route: 'agenda'
    },
    comunicacao: {
        name: 'Comunicação',
        chave_sistema: 'eef9c9c426d1fe9184a138a91ed1a273a13d7901',
        chave_autenticacao: '7b74d5513c1790e10ff3edf50a0f4a6349a7f7db',
        image: 'https://pluri-geral.s3.amazonaws.com/sistemas/parceiros/estudoplay/sistemas/comunicacao.png',
        sspa_name: '@cosmos/comunicacao',
        route: 'comunicacao'
    },
    loja: {
        name: 'Loja',
        chave_sistema: '7de1216b162128efa39bcb16b632dca9f8550778',
        image: 'https://pluri-geral.s3.amazonaws.com/icones_aplicacoes/loja.png',
        sspa_name: '@cosmos/loja',
        route: 'loja'
    },
    led: {
        name: 'Livros Digitais',
        chave_sistema: '632667547e7cd3e0466547863e1207a8c0c0c549',
        image: 'https://pluri-geral.s3.amazonaws.com/sistemas/parceiros/estudoplay/sistemas/biblioteca_digital.png',
        sspa_name: '@cosmos/led',
        route: 'led'
    },
    plataforma: {
        name: 'Pluri Connect',
        chave_sistema: '7b74d5513c1790e10ff3edf50a0f4a6349a7f7db',
        image: 'https://pluri-geral.s3.amazonaws.com/sistemas/parceiros/estudoplay/logo/icone_estudoplay.png',
        sspa_name: '@cosmos/plataforma',
        route: 'plataforma'
    },
    solicitacoes: {
        name: 'Solicitações',
        chave_sistema: 'b934d13c94f658898b44bdb26d69c8aeeda3f2ce',
        image: 'https://pluri-geral.s3.amazonaws.com/icones_aplicacoes/pedidos.png',
        route: ''
    },
    sucessocliente: {
        name: 'Sucesso do Cliente',
        chave_sistema: '07b31f42c6e5dd46ab012e2b976093f5d8e11cb3',
        image: '',
        route: ''
    },
    pluriid: {
        name: 'Pluri ID',
        chave_sistema: '356a192b7913b04c54574d18c28d46e6395428ab',
        image: '',
        route: ''
    },
    erpcosmos: {
        name: 'ERP Cosmos',
        chave_sistema: '7f52ce429b832bcdf8bfbe5dfba486b365bfebb3',
        image: 'https://pluri-geral.s3.amazonaws.com/icones_aplicacoes/pluri_connect.png',
        route: ''
    },
    'central-de-testes': {
        name: 'Central de Testes',
        chave_sistema: '7f52ce429b832bcdf8bfbe5dfba486b365bfebb1',
        image: 'https://pluri-geral.s3.amazonaws.com/icones_aplicacoes/pluri_connect.png',
        route: 'central-de-testes'
    },
    redacao: {
        name: 'Redação',
        chave_sistema: 'chaveTeste',
        image: 'https://pluri-geral.s3.amazonaws.com/icones_aplicacoes/redacao.png',
        route: 'redacao',
        sspa_name: '@cosmos/redacao'
    },
    chegando: {
        name: 'Chegando',
        chave_sistema: 'fa50bce2fb8aac8ff198cc2d5daaa402bb686265',
        image: 'https://pluri-geral.s3.amazonaws.com/icones_aplicacoes/Fila_Esperta.png',
        route: 'chegando',
        sspa_name: '@cosmos/chegando'
    },
    aulasaovivo: {
        name: 'Aulas ao Vivo',
        chave_sistema: 'dd383b11686528dc0e361c74f5e9bca7b61b0576',
        image: 'https://pluri-geral.s3.amazonaws.com/icones_aplicacoes/aulas_ao_vivo.png',
        route: 'aulasaovivo',
        sspa_name: '@cosmos/aulasaovivo'
    }
};
